import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import {Success} from 'common/models/success';
import {SurveyId} from 'common/models/survey';
import {isEmpty} from 'lodash';
import {setErrorAction} from 'ui/store/system/actions/setError';
import getRequestError from 'ui/store/utils/getRequestError';
import withAbortRequest from 'ui/store/utils/withAbortRequest';
import {sdk} from 'ui/utils/sdk';

import {namespace} from '../constants';
import {AsyncThunkConfig, ReducerCallback} from '../success.types';

interface PrepareSuccess {
    surveyId: SurveyId;
    answerKey: string | null;
}

export const prepareSuccessAction = createAction<Success>(`${namespace}/prepareSuccess`);

export const reducerPrepareSuccess: ReducerCallback<Success> = (state, {payload}) => {
    state.data = payload;
};

const prepareSuccess = createAsyncThunk<void, PrepareSuccess, AsyncThunkConfig<void>>(
    'prepareSuccess',
    async ({surveyId, answerKey}, {getState, signal, dispatch}) => {
        const currentSuccess = getState().success;
        if (isEmpty(currentSuccess)) {
            return withAbortRequest(
                sdk.form.getSuccess({surveyId, answerKey}).then((success) => {
                    dispatch(prepareSuccessAction(success));
                }),
                signal,
            )
                .catch(getRequestError)
                .catch((status) => {
                    dispatch(setErrorAction(status));
                    return status;
                });
        }
        return Promise.resolve();
    },
);

export default prepareSuccess;
